export default "/_next/static/media/tutorial-04.c98c3c002cf27c501410bf24ee4a2459.jpg";